import {savedJourneyCopy,savedJourneyErrorCopy} from '../data/savedJourneysCopy.js';
import {PREPARATION_MACHINE_NOTICE_ENGLISH,preparationMachineNotice} from '../data/preparationQuestionMachineNotices.js';
import {sourceRevision} from './translationAssurance.js';
export function buildSupplementalJourneyTranslationRows(locale) {
  const rows=[];
  const add=(namespace,path,sourceText,originalText,contentArea)=>{
    const id=namespace+':'+path;
    rows.push({id,namespace,path,sourceText,originalText,contentArea,
      sourceRevision:sourceRevision(id,sourceText),publicationTarget:'locale',runtimeFallbackSource:true,
      provenance:'existing Journey runtime copy'});
  };
  const current=savedJourneyCopy(locale);
  for(const [field,source] of Object.entries(savedJourneyCopy('en')))
    add('savedJourneys','labels.'+field,source,current[field],'core_ui');
  for(const reason of ['invalid_link','storage_full','storage_unavailable','verification_failed'])
    add('savedJourneys','errors.'+reason,savedJourneyErrorCopy('en',reason),savedJourneyErrorCopy(locale,reason),'core_ui');
  add('preparationMachineNotice','message',PREPARATION_MACHINE_NOTICE_ENGLISH,preparationMachineNotice(locale),'hospital_journeys');
  return rows;
}
